import React from 'react';
import classnames from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import s from './Page.scss';
var Page = function (_a) {
    var isCurrent = _a.isCurrent, page = _a.page, getPageUrl = _a.getPageUrl, onChangePage = _a.onChangePage, children = _a.children, biData = _a.biData;
    var url = getPageUrl && getPageUrl(page);
    var onClick = onChangePage && (function () { return onChangePage(page); });
    if (isCurrent || (!onClick && !url)) {
        return (React.createElement("div", { className: classnames(s['page'], isCurrent && s['current']) }, children));
    }
    if (url) {
        return (React.createElement(BiLink, { biData: biData, className: s['page'], href: url, onClick: onClick }, children));
    }
    return (React.createElement(BiButton, { biData: biData, className: s['page'], onClick: onClick }, children));
};
Page.displayName = 'Page';
export default Page;
//# sourceMappingURL=Page.js.map